import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import AuthService from "../services/auth.service";

import { withRouter } from "../with-router.tsx";
import BrandLogo from "../components/BrandLogo.tsx";

type LoginProps = {
  router: {
    navigate: (path: string) => void;
  };
};

type LoginState = {
  username: string;
  password: string;
  loading: boolean;
  message: string;
};

type ValidationFormRef = {
  validateAll: () => void;
};

type ValidationButtonRef = {
  context?: {
    _errors?: unknown[];
  };
};

const getErrorMessage = (error: unknown): string => {
  if (typeof error === "object" && error !== null) {
    const apiError = error as {
      response?: { data?: { message?: string } };
      message?: string;
      toString: () => string;
    };

    return (
      apiError.response?.data?.message ||
      apiError.message ||
      apiError.toString()
    );
  }

  return "Unknown error";
};

const required = (value: string) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

class Login extends Component<LoginProps, LoginState> {
  form: ValidationFormRef | null;
  checkBtn: ValidationButtonRef | null;

  constructor(props: LoginProps) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      username: "",
      password: "",
      loading: false,
      message: "",
    };
  }

  onChangeUsername(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      username: e.target.value,
    });
  }

  onChangePassword(e: React.ChangeEvent<HTMLInputElement>) {
    this.setState({
      password: e.target.value,
    });
  }

  handleLogin(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true,
    });

    this.form?.validateAll();

    if ((this.checkBtn?.context?._errors?.length || 0) === 0) {
      AuthService.login(this.state.username, this.state.password).then(
        () => {
          this.props.router.navigate("/home");
          window.location.reload();
        },
        (error) => {
          const resMessage = getErrorMessage(error);

          this.setState({
            loading: false,
            message: resMessage,
          });
        }
      );
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  render() {
    return (
      <div className="col-md-12">
        <div className="card card-container" style={stylingObject.center}>
          <BrandLogo
            alt="profile-img"
            className="profile-img-card"
            width={200}
          />

          <Form
            onSubmit={this.handleLogin}
            ref={(c) => {
              this.form = c as unknown as ValidationFormRef;
            }}
          >
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <Input
                type="text"
                className="form-control"
                name="username"
                value={this.state.username}
                onChange={this.onChangeUsername}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <Input
                type="password"
                className="form-control"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
              />
            </div>

            <div className="form-group" style={stylingObject.loginButton}>
              <button
                className="btn btn-primary btn-block"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Login</span>
              </button>
            </div>

            {this.state.message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {this.state.message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={(c) => {
                this.checkBtn = c as unknown as ValidationButtonRef;
              }}
            />
          </Form>
        </div>
      </div>
    );
  }
}

const stylingObject = {
  center: {
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
  },
  loginButton: {
    padding: 10,
    // minWidth: 00,
  },
};


export default withRouter(Login);
